import { polyfill as seamlessScrollPolyfill } from 'seamless-scroll-polyfill';

/* 
 * Additional browser polyfills can be added using the tool below:
 * 
 * Polyfill service v3.96.0
 * For detailed credits and licence information see https://github.com/financial-times/polyfill-service.
 * 
 */

// Element.prototype.matches
Element.prototype.matches = Element.prototype.webkitMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.mozMatchesSelector;

// Check for scroll support, IE11 needs this...
const supportsNativeSmoothScroll = 'scrollBehavior' in document.documentElement.style;

// Patch browser if scrollBehavior is missing
if (!supportsNativeSmoothScroll) {
    seamlessScrollPolyfill();
}
